import { render, staticRenderFns } from "./ViewMemoModal.vue?vue&type=template&id=56a3b2ee&scoped=true"
import script from "./ViewMemoModal.vue?vue&type=script&lang=js"
export * from "./ViewMemoModal.vue?vue&type=script&lang=js"
import style0 from "./ViewMemoModal.vue?vue&type=style&index=0&id=56a3b2ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a3b2ee",
  null
  
)

export default component.exports